// routes/GoogleAuthCallback.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COOKIE_EXPIRE } from "../utils/api";

const ROLE_REDIRECT = {
  1: "/userprofile",
  2: "/teacher",
  3: "/people",
};

const GoogleAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const validateSession = async () => {
      try {
         console.error("validate session starts Missing token or role:");
        const resp = await axios.get(COOKIE_EXPIRE, { withCredentials: true });

        const token = resp.data?.access_token;
        const role = Number(resp.data?.role_id);

        // FIX 3: validate before saving — prevents "undefined"/"NaN" in localStorage
        if (!token || !role) {
          console.error("Missing token or role:", resp.data);
          navigate("/", { replace: true });
          return;
        }

        localStorage.setItem("access_token", token);
        localStorage.setItem("role", role.toString());

        navigate(ROLE_REDIRECT[role] || "/userprofile", { replace: true });

      } catch (err) {
        console.error("Google login failed:", err);
        navigate("/", { replace: true });
      }
    };

    validateSession();
  }, []); // empty array — no need for navigate as dep, avoids double-call

  return <div>Logging you in securely...</div>;
};

export default GoogleAuthCallback;